import { useState } from 'react';
import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import { Box, Button, Image, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { uploadFile } from '../lib/upload';

interface FileUploadProps {
  value: string | null;
  onChange: (path: string | null) => void;
  accept?: 'image' | 'file';
  fileTypes?: Record<string, string[]>;
}

export default function FileUpload({ value, onChange, accept = 'file', fileTypes }: FileUploadProps) {
  const isImage = accept === 'image';
  const [uploading, setUploading] = useState(false);

  async function uploadFiles(files: File[]) {
    const file = files[0];
    if (!file) return;
    setUploading(true);
    try {
      const uploaded = await uploadFile(file);
      if (uploaded) onChange(uploaded.path);
    } finally {
      setUploading(false);
    }
  }

  return (
    <Box>
      {value && isImage && (
        <Image src={`/uploads/${value}`} alt="" mah={120} maw={200} fit="contain" mb="sm" />
      )}
      {value && !isImage && (
        <Text mb="sm">Current file: <strong>{value}</strong></Text>
      )}

      <Dropzone
        onDrop={uploadFiles}
        onReject={() => notifications.show({ color: 'red', message: 'This file type is not accepted here' })}
        accept={isImage ? IMAGE_MIME_TYPE : fileTypes}
        multiple={false}
        loading={uploading}
      >
        <Text ta="center" p="md">Drag a file here, or click to select</Text>
      </Dropzone>

      {value && (
        <Button variant="subtle" color="red" size="xs" mt="sm" onClick={() => onChange(null)}>
          Remove
        </Button>
      )}
    </Box>
  );
}
